import React from 'react';
import styles from './BookFooter.module.css';

interface FooterProps {
  email: string,
  note: string,
  numberOfPage: number,
}

export const BookFooter: React.FC<FooterProps> = ({email, note, numberOfPage}) => (
  <footer className={styles.footer}>
    <hr className={styles.footerLine} />
    <p>Email: <a href={"mailto:" + email} className={styles.accentLink}>{email}</a></p>
    <p className={styles.note}>{note}</p>
    <p className={styles.pageNumber}>Page {numberOfPage}</p>
  </footer>
);
